import API from './phx';
import * as utils from '../utils/OrderUtils';

const addOrderLog = async (orderId, description) => {
  const fetchUrl = utils.appendGeoParam(`/orders/${orderId}/order_log`);
  try {
    const response = await API.post(fetchUrl, {
      date: utils.getTimeInUTC(),
      description,
    });
    return response.data;
  } catch (error) {
    console.error('Error adding order log:', error);
    throw error;
  }
};

export default addOrderLog;
